import React from 'react'
import { LoadingProps } from './Loading.types'
import {
  LoadingContainer,
  SpinnerWrapper,
  DotsWrapper,
  Dot,
  PulseWrapper,
  BarsWrapper,
  Bar,
  LoadingText,
} from './Loading.styles'
import { Icon } from '../Icon'

export const Loading: React.FC<LoadingProps> = ({
  size = 'medium',
  variant = 'spinner',
  color,
  text,
  showText = false,
  className,
  style,
  center = false,
  speed = 'normal',
}) => {
  const renderLoadingIndicator = () => {
    switch (variant) {
      case 'spinner':
        return (
          <SpinnerWrapper
            $size={size}
            $color={color}
            $center={center}
            $speed={speed}
          />
        )

      case 'dots':
        return (
          <DotsWrapper
            $size={size}
            $color={color}
            $center={center}
            $speed={speed}
          >
            {[0, 1, 2].map((index) => (
              <Dot
                key={index}
                $size={size}
                $color={color}
                $center={center}
                $speed={speed}
                $delay={index}
              />
            ))}
          </DotsWrapper>
        )

      case 'pulse':
        return (
          <PulseWrapper
            $size={size}
            $color={color}
            $center={center}
            $speed={speed}
          />
        )

      case 'bars':
        return (
          <BarsWrapper
            $size={size}
            $color={color}
            $center={center}
            $speed={speed}
          >
            {[0, 1, 2, 3].map((index) => (
              <Bar
                key={index}
                $size={size}
                $color={color}
                $center={center}
                $speed={speed}
                $delay={index}
              />
            ))}
          </BarsWrapper>
        )

      default:
        return (
          <Icon
            name="loading"
            size={size}
            color={color}
            style={{
              animation: `spin ${speed === 'slow' ? '2s' : speed === 'fast' ? '0.5s' : '1s'} linear infinite`,
            }}
          />
        )
    }
  }

  return (
    <LoadingContainer
      $size={size}
      $color={color}
      $center={center}
      $speed={speed}
      className={className}
      style={style}
      role="progressbar"
      aria-label={text || 'Loading'}
    >
      {renderLoadingIndicator()}
      {(showText || text) && (
        <LoadingText
          $size={size}
          $color={color}
          $center={center}
          $speed={speed}
        >
          {text || 'Loading...'}
        </LoadingText>
      )}
    </LoadingContainer>
  )
}
